import { Component, OnChanges, inject, ChangeDetectionStrategy, input, output } from '@angular/core';
import {GuruEntity} from "../../../../model/guru-entity";
import {ConfigurationSection, UserStateService} from "../../../../services/user-state.service";
import {ModelService} from "../../../../services/model-service";
import {SelectionUtils} from "../../../selection-utils";
import {MatIcon} from "@angular/material/icon";

import {ReactiveFormsModule} from "@angular/forms";

@Component({
    selector: 'app-vertical-sm-com-accessories',
    imports: [
    MatIcon,
    ReactiveFormsModule
],
    templateUrl: './vertical-sm-com-accessories.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    styleUrl: './vertical-sm-com-accessories.component.css'
})
export class VerticalSmComAccessoriesComponent implements OnChanges {
  private readonly modelService = inject(ModelService);
  private readonly userStateService = inject(UserStateService);
  readonly invalidEntities = input.required<string[]>();
  readonly engineKey = input.required<string>();
  readonly selectionEntities = input.required<GuruEntity[]>();
  readonly valueChanged = output<void>();
  replacementFilterSelection!: GuruEntity;
  stackKitsSelection!: GuruEntity;
  stackAccessoriesSelection!: GuruEntity;
  stackBallValveAssembliesSelection!: GuruEntity;
  hoseKitsSelection!: GuruEntity;
  stackCabinetStandSelection!: GuruEntity;
  heightSelection!: GuruEntity;
  isoPadSelection!: GuruEntity;
  stackReturnPanelSelection!: GuruEntity;
  returnPanelFinishSelection!: GuruEntity;
  returnPanelTypeSelection!: GuruEntity;
  stackSupplyAirGrilleSelection!: GuruEntity;
  supplyGrilleFinishSelection!: GuruEntity;
  supplyGrilleDimensionsSelection!: GuruEntity;
  thermostatSelection!: GuruEntity;
  controlsSelection!: GuruEntity;
  isExpanded = true;
  private sectionKey = ConfigurationSection.ACCESSORIES;

  constructor() {
    this.isExpanded = !this.userStateService.isConfigurationSectionCollapsed(this.sectionKey);
  }

  ngOnChanges(): void {
    this.replacementFilterSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USFilter');
    this.stackKitsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USVerticalStackKit');
    this.stackAccessoriesSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USAccessories');
    this.stackBallValveAssembliesSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USBallValveAssemblies');
    this.hoseKitsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USHoseKit');
    this.stackCabinetStandSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetStand');
    this.heightSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetStandHeight');
    this.isoPadSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USCabinetStandISO');
    this.stackReturnPanelSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRAPanel');
    this.returnPanelFinishSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRAPanelFinish');
    this.returnPanelTypeSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USRAPanelType');
    this.stackSupplyAirGrilleSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSAGrille');
    this.supplyGrilleFinishSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSAGrilleFinish');
    this.supplyGrilleDimensionsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USSAGrilleSize');
    this.thermostatSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USThermostat');
    this.controlsSelection = SelectionUtils.getEntity(this.selectionEntities(), 'USControlsACC');
  }

  selectionChanged(entity: GuruEntity, newValue: string): void {
    entity.Value = newValue;
    this.modelService.setValue(entity.Name, this.engineKey(), newValue).subscribe(() => this.valueChanged.emit());
  }

  toggleExpansion(): void {
    this.isExpanded = !this.isExpanded;
    this.userStateService.setCollapsedValue(this.sectionKey, this.isExpanded);
  }

  getExpansionIcon(): string {
    return this.isExpanded ? 'arrow_drop_up' : 'arrow_drop_down';
  }

  isInvalidSelection(entityName: string) {
    return this.invalidEntities() && this.invalidEntities().indexOf(entityName) >= 0;
  }

}
